import {getCurrentDestinationIndex} from './resultsNavigator';

export function resetAnalytics(analytics, term) {
    return {
        ...analytics,
        backspaceCounter: 0,
        noSelectionCounter: 0,
        prevSearch: term
    };
}

export function getRecentDisplayedNumber(results) {
    return results.reduce((recentsNumber, result) => {
        if (result.recentlyviewed) {
            recentsNumber++;
        }
        return recentsNumber;
    }, 0);
}

export function getSelectionDepth(index) {
    const currentIndex = getCurrentDestinationIndex(index);
    return currentIndex + 1; // 1-based selectionDepth
}

function isResultChanged(results, nextResults) {
    if (results.length !== nextResults.length) {
        return true;
    }
    return nextResults.find((element, index) => {
        return !results[index] || results[index].uuid !== element.uuid;
    });
}

function emptyResults(results, nextResults) {
    return (
        !results ||
        !nextResults ||
        (results.length === 0 && nextResults.length === 0)
    );
}

export function incrementNoSelectionCounter(results, nextResults, counter) {
    if (
        emptyResults(results, nextResults) ||
        !isResultChanged(results, nextResults)
    ) {
        return counter;
    }
    return ++counter;
}

export function getNearbySearchesNumber(destinations) {
    let count = 0;
    destinations.map((destination) => {
        if (destination.matchType === 'RECO') {
            count++;
        }
    });
    return count;
}
